/**
 * Feature Flags: Common methods.
 */

/** @internal */
export const FEATURE_FLAGS_LOGGER_COMPONENT = 'featureFlags';

// Used for validating app ids and feature ids.
/** @internal */
export let IdType = /*#__PURE__*/function (IdType) {
  IdType["App"] = "app";
  IdType["Feature"] = "feature";
  IdType["User"] = "user";
  IdType["Group"] = "group";
  return IdType;
}({});

// *** General-purpose Methods ***

// Create an error object with a given name.
/** @internal */
export function createNamedError(name, message) {
  const err = new Error(message);
  err.name = name;
  return err;
}

// Create a formatter function for sending messages to a logger.
/** @internal */
export function createLogMsgFormatter(submodule) {
  return msg => {
    const svcMsg = msg.response?.data?.message;
    return `(${submodule}) ${svcMsg ? `ServiceError: ${svcMsg}` : msg}`;
  };
}

// *** Common REST Methods ***

// Finds a HATEOAS link object with the matching relation; otherwise returns undefined.
/** @internal */
export function findLink(links, rel) {
  return links ? links.find(link => link.rel === rel) : undefined;
}

// Converts an array of HATEOAS link objects into a map by link relation.
/** @internal */
export function createLinkMap(links) {
  return links ? links.reduce((map, link) => {
    if (link.rel) {
      map[link.rel] = link;
    }
    return map;
  }, {}) : {};
}

// *** Helper Methods Specific to Feature Flags ***

// Throw error if any id is invalid.
/** @internal */
export function validateIds(ids, idType) {
  // will throw error if any id is invalid
  ids.forEach(id => validateId(id, idType));
}

// Throw error if id is invalid.
/** @internal */
export function validateId(id, idType) {
  // commas are invalid characters due to CSV-style filters in URI query parameters
  if (typeof id !== 'string' || id === '' || id !== id.trim() || id.includes(',')) {
    throw createNamedError('NameError', `invalid ${idType} id: '${id}'`);
  }
}
//# sourceMappingURL=common.js.map